import { render, staticRenderFns } from "./ToggleTableCellsContainer.vue?vue&type=template&id=013454e1&"
import script from "./ToggleTableCellsContainer.vue?vue&type=script&lang=ts&"
export * from "./ToggleTableCellsContainer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports